import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { store } from 'store';

import * as S from './CopyTradingToggle.styles';

export const CopyTradingToggle: FC = observer(() => {
  const { mode } = store.commonStore;
  const { toggleAutopilot } = store.galaxyStore;

  return (
    <S.ToggleButton
      $isActive={mode === 'autopilot'}
      $isVisible={mode === 'pilot' || mode === 'autopilot'}
      onClick={toggleAutopilot}
    >
      {mode === 'autopilot' ? 'Off' : 'On'}
    </S.ToggleButton>
  );
});
